<template>
  <div class="rink">
    <modal-card>
      <div v-if="initialized && rink">
        <h1>{{ rink.name }}</h1>
        <h2>{{ rink.address }}</h2>
        <div class="rink-card-content">

          <div class="rink-status" v-if="rink.latest">
            <md-avatar class="md-avatar-icon" :class="rink.latest.ouv == '1' ? 'rink-status-pos' : 'rink-status-neg'">
              <md-icon>access_time</md-icon>
              <md-tooltip md-direction="bottom">Ouvert</md-tooltip>
            </md-avatar>

            <md-avatar class="md-avatar-icon" :class="rink.latest.deb == '1' ? 'rink-status-pos' : 'rink-status-neg'">
              <md-icon>ac_unit</md-icon>
              <md-tooltip md-direction="bottom">Déblayée</md-tooltip>
            </md-avatar>

            <md-avatar class="md-avatar-icon" :class="rink.latest.arr == '1' ? 'rink-status-pos' : 'rink-status-neg'">
              <md-icon>opacity</md-icon>
              <md-tooltip md-direction="bottom">Arrosée</md-tooltip>
            </md-avatar>

            <md-avatar class="md-avatar-icon" :class="rink.latest.res == '1' ? 'rink-status-pos' : 'rink-status-neg'">
              <md-icon>local_shipping</md-icon>
              <md-tooltip md-direction="bottom">Resurfacée</md-tooltip>
            </md-avatar>
          </div>

          <div class="rink-card-row" v-if="rink.latest">
            Dernière mise à jour
            <md-chip>{{ fromNow(rink.latest.timestamp) }}</md-chip>
          </div>

          <div class="rink-card-row" v-if="rink.latest && rink.latest.condition && rink.latest.condition != 'N/A'">
            Condition
            <md-chip>{{ rink.latest.condition }}</md-chip>
          </div>

          <transition name="slide-fade" mode="out-in">
            <div class="history-section" v-if="lastYearOpening || lastYearWeekHistory.length > 0">
              <div class="year-title">En 2018-2019</div>

              <div class="rink-card-row" v-if="lastYearOpening">
                Ouverture
                <md-chip
                  ><strong>{{ lastYearOpening }}</strong></md-chip
                >
              </div>

              <div class="week-history">
                <md-avatar class="md-avatar-icon md-small" 
                  v-for="item in lastYearWeekHistory" :key="item.day"
                  :class="{
                    'rink-status-pos': item.open == true,
                    'rink-status-neg': item.open == false
                  }">{{ item.day }}</md-avatar>
              </div>
            </div>
          </transition>

          <!-- <div class="rink-card-row" v-if="rink.description">
            Description <md-chip>{{ rink.description }}</md-chip>
          </div> -->
          <!-- <div class="rink-card-row" v-if="rink.type">
            Type <md-chip>{{ rink.type }}</md-chip>
          </div> -->

          <router-link v-bind:to="'/commentaires?patinoire=' + $route.params.id"
            >Signaler une erreur</router-link
          >
        </div>
      </div>

      <!-- <template v-slot:actions>
        <router-link v-bind:to="'/historique?patinoire=' + $route.params.id">
          <md-button class="md-fab md-mini md-primary button-right">
            <md-icon>bar_chart</md-icon>
          </md-button>
        </router-link>
      </template> -->
    </modal-card>
  </div>
</template>

<style scoped>
h1 {
  font-size: 2.5em;
  line-height: 0.9em;
  text-align: center;
  margin: 0;
}
h2 {
  text-align: center;
  color: #777;
}

.year-title {
  font-family: "Staatliches", cursive;
  font-size: 2em;
  line-height: 0.9em;
  font-weight: bold;
  margin-bottom: 20px;
}

.rink-card-content {
  font-family: "Montserrat", sans-serif;
  text-align: center;
}
.rink-card-row {
  margin: 5px 0;
}
.rink-status .md-avatar {
  margin: 0 2.5px;
}
.rink-status-pos {
  background: #09f !important;
}
.rink-status-neg {
  background: #bc5247 !important;
}


.history-section {
  background: #f0f0f0;
  border-radius: 20px;
  padding: 20px;
  margin: 10px 0;
}

.week-history .md-avatar {
  font-family: "Staatliches", cursive;
  letter-spacing: 1px;
  line-height: 1.4em;
  padding-left: 2px;
  margin: 0 2.5px;
}
</style>

<script>
import { EventBus } from "../main";
import interact from "interactjs";
import ModalCard from "../components/ModalCard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

export default {
  name: "rink",
  components: {
    ModalCard
  },
  data: () => ({
    initialized: false,
    rink: null,
    lastYearOpening: null,
    lastYearWeekHistory: [],
  }),
  // watch: {
  //   $route: function(obj) {
  //     this.loadRinkFromId(obj.params.id);
  //   }
  // },
  mounted() {
    if (EventBus.initialized) {
      this.setInitialized();
    } else {
      EventBus.$on("initialized", this.setInitialized);
    }
  },
  beforeDestroy() {
    EventBus.$off("initialized");
  },
  methods: {
    setInitialized() {
      this.initialized = true;

      this.loadRinkFromId(this.$route.params.id);
    },
    fromNow(timestamp) {
      return dayjs(timestamp).fromNow();
    },
    goBack() {
      this.$router.push("/");
    },
    async loadRinkFromId(id) {
      this.rink = null;
      this.lastYearOpening = null;

      let enc_id = encodeURIComponent(id).replace(/\./g, "%2E");

      let rink = EventBus.getRink(enc_id);
      if (rink) {
        this.rink = rink;
        let lastYearOpening = await EventBus.getRinkHistory(rink.name);
        if (lastYearOpening) {
          lastYearOpening = dayjs(lastYearOpening, "YYYY-MM-DD").format(
            "D MMMM"
          );
        }
        this.lastYearOpening = lastYearOpening;

        let history = await EventBus.getRinkLastYearWeekHistory(rink.name);

        let cursorDate = dayjs().set('y', (dayjs().year() - 1));
        for (let i=0; i<7; i++) {
          let currentDate = cursorDate.format('YYYY-MM-DD');
          let day = cursorDate.format('D');
          let open = null;
          if (history[currentDate]) {
            open = history[currentDate][0] === "1";
          }
          this.lastYearWeekHistory.push({day, open});
          cursorDate = cursorDate.add(1, 'd');
        }

      } else {
        this.goBack();
      }
    }
  },
};
</script>
